import { useEffect, useState } from 'react';
import { Protocol } from 'pmtiles';
import maplibregl from 'maplibre-gl';

let protocolRegistered = false;

function registerPmtilesProtocol(): void {
  if (protocolRegistered) return;
  const protocol = new Protocol();
  maplibregl.addProtocol('pmtiles', protocol.tile);
  protocolRegistered = true;
}

/**
 * Ensures the PMTiles protocol is registered with MapLibre exactly once.
 */
export function useOfflineMap(): { isProtocolReady: boolean } {
  const [isProtocolReady, setIsProtocolReady] = useState(protocolRegistered);

  useEffect(() => {
    registerPmtilesProtocol();
    setIsProtocolReady(true);
  }, []);

  return { isProtocolReady };
}

export { registerPmtilesProtocol };
